import type { FC } from 'react';
import classnames from 'classnames';

import Icon from 'app/components/Icon';
import warningIcon from 'app/icons/warning.svg';

import IncidentTooltip from './IncidentTooltip';
import style from './style.scss';

interface Props {
  incidents: MatchIncident[];
  alignment: 'start' | 'end' | 'middle';
  className?: string;
}

const IncidentIndicator: FC<Props> = ({ incidents, alignment, className }) => {
  const iconClassName = classnames(style.warningIcon, {
    [style.warningIcon_private]: incidents.every(incident => incident.private_notes !== null),
    [style.warningIcon_all]:
      incidents.some(incident => incident.notes !== null) &&
      incidents.some(incident => incident.private_notes !== null)
  });

  return (
    <IncidentTooltip
      className={className}
      contentClassName={style.tooltip}
      alignment={alignment}
      incidents={incidents}
    >
      <Icon href={warningIcon} className={iconClassName} />
    </IncidentTooltip>
  );
};

IncidentIndicator.displayName = 'IncidentIndicator';

export default IncidentIndicator;
